var portfolioEvaluationChart = {
	"3m": "3M",
	"1y": "1A",
	"1stTrade": "Depuis la 1ère Transaction",
	rangeDescription: "Plage de {start} à {end}"
};
var fr = {
	portfolioEvaluationChart: portfolioEvaluationChart
};

export { fr as default, portfolioEvaluationChart };
